import { useMutation, useQueryClient } from "@tanstack/react-query";
import client from "api/graphql/getClient";
import { graphql } from "gql/gql";
import { DeleteMsTeamsWebhookParams } from "gql/graphql";
import { useActiveAccount } from "utils/useActiveAccount";

const deleteMsTeamsWebhookDocument = graphql(/* GraphQL */ `
	mutation deleteMsTeamsWebhook($params: DeleteMsTeamsWebhookParams!) {
		deleteMsTeamsWebhook(params: $params) {
			error {
				code
				message
			}
			success
		}
	}
`);

interface Args {
	params: DeleteMsTeamsWebhookParams;
	userId?: string;
}

const deleteMsTeamsWebhook = ({ userId, params }: Args) =>
	client(userId)
		.request(deleteMsTeamsWebhookDocument, { params })
		.then((res) => res.deleteMsTeamsWebhook);

const useDeleteMsTeamsWebhook = () => {
	const { userId, _id } = useActiveAccount();
	const queryClient = useQueryClient();

	return useMutation(
		(params: DeleteMsTeamsWebhookParams) =>
			deleteMsTeamsWebhook({ params, userId }),
		{
			onSettled: () => {
				queryClient.invalidateQueries([
					"user",
					userId,
					"account",
					_id,
					"msTeamsWebhooks",
				]);
			},
		}
	);
};

export default useDeleteMsTeamsWebhook;
